import {useEffect} from 'react';
import {callSoopBridge} from '@/utils/channel/soopBridge';

const disableRefreshState = {
  count: 0,
};

type UseDisableRefreshOptions = {
  releaseOnUnmount?: boolean;
};

/**
 * pull-to-refresh 비활성화를 브릿지로 반영합니다.
 * @param isDisabled true면 비활성화, false면 복구합니다.
 */
const applyDisableRefresh = (isDisabled: boolean): void => {
  callSoopBridge({action: 'setDisableRefresh', value: isDisabled});
};

/**
 * pull-to-refresh 비활성화 획득 횟수를 증가시킵니다.
 */
const acquireDisableRefresh = (): void => {
  if (disableRefreshState.count === 0) {
    applyDisableRefresh(true);
  }
  disableRefreshState.count += 1;
};

/**
 * pull-to-refresh 비활성화 획득 횟수를 감소시킵니다.
 */
const releaseDisableRefresh = (): void => {
  if (disableRefreshState.count === 0) {
    return;
  }

  disableRefreshState.count -= 1;
  if (disableRefreshState.count === 0) {
    applyDisableRefresh(false);
  }
};

/**
 * 앱 웹뷰에서 pull-to-refresh 비활성화를 제어합니다.
 * @param isDisabled true면 마운트 시 비활성화하고 언마운트 시 복구합니다.
 * @param options 언마운트 시 복구 여부를 제어합니다.
 */
export function useDisableRefresh(
  isDisabled: boolean = true,
  options: UseDisableRefreshOptions = {},
) {
  const releaseOnUnmount = options.releaseOnUnmount ?? true;

  useEffect(() => {
    if (!isDisabled) {
      return;
    }

    acquireDisableRefresh();

    return () => {
      if (releaseOnUnmount) {
        releaseDisableRefresh();
      }
    };
  }, [isDisabled, releaseOnUnmount]);
}
